import React from "react";
import { Link } from "react-router-dom";

// The logo always goes to the marketing home; `/` bounces returning members to Chatter.
export const Logo = ({ size = 36, withText = true, className = "" }) => {
  return (
    <Link to="/home" className={`inline-flex items-center ${className}`} data-testid="brand-logo">
      {withText && (
        <span className="text-[17px] font-[650] tracking-[-0.01em] text-foreground">
          Startup<span className="text-primary">Otter</span>
        </span>
      )}
    </Link>
  );
};
